import { CatalogItemType } from '@common/model/catalog/item/type';
import React from 'react';
import { CatalogItemViewBaseProps } from './view.props';

export type ICatalogItemViewContext = Record<CatalogItemType, React.ComponentType<CatalogItemViewBaseProps>>;

export const CatalogItemViewContext = React.createContext<ICatalogItemViewContext>({
  [CatalogItemType.Resume]: () => null,
  [CatalogItemType.Vacancy]: () => null,
});
